import { createReducer, getArrayAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { ScaleType } from './scaleType.types';
import { getScaleTypeList } from './scaleType.actions';

export type ScaleTypeState = ScaleType[];

export const initialState: ScaleTypeState = [];

const scaleTypeReducer = createReducer(initialState, {
  [getScaleTypeList.done.type]: (state: ScaleTypeState, action) => getArrayAfterAsyncCall<ScaleType>(state, action),
});

export default scaleTypeReducer;
